import type { WeightBandInput } from '@chukua/common';
import { api } from '../../../../shared/shared.api';
import { listWeightBands, type WeightBand } from '../../reference-data.api';
import type { CatalogueApi } from '../../hooks/use-catalogue';

/** Admin-managed (`configuration.manage`, gitaumoses4/chukua#355); the list call and row type are shared with the pickers, so they stay in `reference-data.api.ts`. */
export const weightBandsApi: CatalogueApi<WeightBand, WeightBandInput> = {
  list: listWeightBands,
  create: (input) => api<WeightBand>('/weight-bands', { method: 'POST', body: JSON.stringify(input) }),
  update: (id, input) => api<WeightBand>(`/weight-bands/${id}`, { method: 'PATCH', body: JSON.stringify(input) }),
  deactivate: async (id) => {
    await api<void>(`/weight-bands/${id}/deactivate`, { method: 'POST' });
  },
  reactivate: async (id) => {
    await api<void>(`/weight-bands/${id}/reactivate`, { method: 'POST' });
  },
};
